module.exports = __webpack_public_path__ + "media/41.5d265258.mp3";